import React from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '../common/EmptyState';

const ReleaseCard = ({ release }) => (
  <Link
    to={release.d2f_artists?.slug ? `/${release.d2f_artists.slug}` : '#'}
    className="flex items-center gap-5 p-5 bg-zinc-900/30 border border-zinc-800/50 rounded-2xl hover:bg-zinc-900 hover:border-zinc-700 transition-all group"
  >
    <div className="w-16 h-16 rounded-xl overflow-hidden bg-zinc-800 flex-shrink-0">
      {release.cover_image ? (
        <img
          src={release.cover_image}
          alt={release.title}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-2xl">🎵</div>
      )}
    </div>
    <div className="flex-1 min-w-0">
      <p className="font-black text-white uppercase tracking-tight truncate">{release.title}</p>
      <p className="text-zinc-400 text-xs font-bold uppercase tracking-widest mt-1 truncate">
        {release.d2f_artists?.name || 'Unknown'} · {release.type}
      </p>
    </div>
    <span className={`text-xs font-black tracking-widest uppercase px-3 py-1.5 rounded-full flex-shrink-0 ${
      release.is_exclusive
        ? 'bg-blue-500/20 text-blue-400 border border-blue-500/30'
        : 'bg-zinc-800 text-zinc-400'
    }`}>
      {release.is_exclusive ? 'Excl.' : 'Free'}
    </span>
  </Link>
);

const LatestReleases = ({ releases }) => {
  if (!releases?.length) return <EmptyState title="No releases yet" subtitle="New music will appear here." />;
  return (
    <div className="space-y-3">
      {releases.map(r => <ReleaseCard key={r.id} release={r} />)}
    </div>
  );
};

export default LatestReleases;